(() => {
  const fragrances = document.querySelector(
    ".variations.variations--fragrances"
  );
  const track = fragrances.querySelector(".product-form__input-inner");
  const prevButton = document.querySelector(
    ".product-form__header-arrow--left"
  );
  const nextButton = document.querySelector(
    ".product-form__header-arrow--right"
  );

  if (!fragrances || !prevButton || !nextButton) {
    return;
  }

  if (track) {
    if (track.scrollLeft <= 0) {
      prevButton.setAttribute("disabled", "");
    }

    prevButton.addEventListener("click", () => {
      nextButton.removeAttribute("disabled");

      track.scrollTo({
        left: track.scrollLeft - track.firstElementChild.offsetWidth,
        behavior: "smooth",
      });
    });

    nextButton.addEventListener("click", () => {
      prevButton.removeAttribute("disabled");

      track.scrollTo({
        left: track.scrollLeft + track.firstElementChild.offsetWidth,
        behavior: "smooth",
      });
    });

    track.addEventListener("scroll", () => {
      const trackScrollWidth = track.scrollWidth;
      const trackOuterWidth = track.clientWidth;

      prevButton.removeAttribute("disabled");
      nextButton.removeAttribute("disabled");

      if (track.scrollLeft <= 0) {
        prevButton.setAttribute("disabled", "");
      }

      if (track.scrollLeft === trackScrollWidth - trackOuterWidth) {
        nextButton.setAttribute("disabled", "");
      }
    });
  }
})();
